<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="admin-settings-deleted-claim-history-title">
                {{ $t('company.deleted_claim_history.title') }}
            </div>
        </div>
        <deleted-log-table :is_admin_section="true" ref="DeletedLogsTable"></deleted-log-table>
    </div>
</template>

<script>
import DeletedLogTable from '@/components/tables/DeletedLogs.vue';

export default {
    components: {
        DeletedLogTable,
    },
    methods: {
        reload() {
            this.$refs.DeletedLogsTable.reload();
        },
    },
};
</script>
